import React, {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../../../reducers'
import {bindActionCreators} from 'redux'
import {actionComprobanteRetencionProducto} from '../../../../actions/action-creators'
import TablaFacturacionCRE from './TablaFacturacionCRE'

const CRETable1 = () => {
  const documentosAsociados = useSelector((state: State) => state.comprobanteRetencion.documentosAsociados)
  const calculos = useSelector((state: State) => state.comprobanteRetencion.calculosArrayProductos)
  const dispatch = useDispatch()
  const {comprobanteRetencionCalculoTotalArrayProducto} = bindActionCreators(actionComprobanteRetencionProducto, dispatch)

  useEffect(() => {
    comprobanteRetencionCalculoTotalArrayProducto()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentosAsociados])

  return (
    <>
      <h3 className='card-title l'>Detalle de Documentos Asociados</h3>
      <div className='form-separator'></div>
      <TablaFacturacionCRE documentos={documentosAsociados} datos={calculos} sinAcciones={false}  />
    </>
  )
}


export default CRETable1
